import { render, staticRenderFns } from "./DocumentParticipationCard.vue?vue&type=template&id=385b5002&scoped=true&lang=pug"
import script from "./DocumentParticipationCard.vue?vue&type=script&lang=js"
export * from "./DocumentParticipationCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentParticipationCard.vue?vue&type=style&index=0&id=385b5002&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b5002",
  null
  
)

export default component.exports